module.exports = __webpack_public_path__ + "img/joinStraightWhite.6e653d5a.svg";